// extracted by mini-css-extract-plugin
module.exports = {"hideTokensHeader":"styles_hideTokensHeader__TAiCo","wrapper":"styles_wrapper__9V_ep","cancelButton":"styles_cancelButton__TQwR0","applyButton":"styles_applyButton__asHCW"};